import SearchIcon from '@atlaskit/icon/core/search';
import * as React from 'react';

export function SvgSearch() {
  return <SearchIcon label="" testId="ads-refreshed-icon" />;
}
